import { render } from "./LoginRegister.vue?vue&type=template&id=e5683874&scoped=true"
import script from "./LoginRegister.vue?vue&type=script&lang=js"
export * from "./LoginRegister.vue?vue&type=script&lang=js"

import "./LoginRegister.vue?vue&type=style&index=0&id=e5683874&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5683874"]])

export default __exports__